import React from "react";
import Layout from "../../Layouts/Layout";
import Lists from "./Lists";

const Subjects = () => {
	return (
		<Layout>
			<div className="bg-subject flex justify-center items-center mb-8">
				<h2 className="text-4xl font-bold font-lobster text-white z-50">
					Tous les sujets et corrigés
				</h2>
			</div>
			<Lists total={24} />
		</Layout>
	);
};

export default Subjects;
